import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex flex-col min-h-screen" data-id="element-114">
      <Navbar data-id="element-115" />
      <main className="flex-grow" data-id="element-116">
        <Outlet data-id="element-117" />
      </main>
      <Footer data-id="element-118" />
    </div>;
}